import {HttpClient, HttpHeaders, HttpRequest} from '@angular/common/http';

import {map, Observable} from "rxjs";
import {Token} from "../../../models/token";
import {Router} from "@angular/router";


export class AbstractRESTService {

    constructor(public http: HttpClient,
                public baseUrl: string,
                public router: Router) {
    }

    protected createCustomHeaders() {
        let headers = {};
        let token = localStorage.getItem(Token.tokeNameInSotage);
        if (token) {
            headers['Authorization'] = 'Bearer ' + token
        }

        return {
            headers: new HttpHeaders(headers),
        };
	}

	protected handleResponse(res) {
		let contentType = res.headers.get("Content-Type");

		if (!contentType) return; // silently abort
		if (res.status !== 200) {
			if (res.status === 401) {
				if (this.router) {
					this.router.navigate(['/login']);
					return;
				}
			}
			throw new Error("Technical problem");
		}
		contentType = contentType.toLowerCase();
		if (contentType.includes("application/json")) {
			try {
				return res.body;
			} catch (e) { //TODO: this should really not happen on backend
				// ignore
			}
		}
		if (contentType.includes("text/plain")) {
			return res.text();
		}
		return res;
	}


    get(url: string): Observable<any> {
        return this.http.get(this.baseUrl + url, {...this.createCustomHeaders(), observe: 'response'}).pipe(map(this.handleResponse));
    }

    post(url: string, data): Observable<any> {
        return this.postRaw(url, data).pipe(map(this.handleResponse));
    }

    postRaw(url: string, data): Observable<any> {
        return this.http.post(this.baseUrl + url, data, {...this.createCustomHeaders(), observe: 'response'});
    }

    put(url: string, data): Observable<any> {
        return this.http.put(this.baseUrl + url, data, {...this.createCustomHeaders(), observe: 'response'}).pipe(map(this.handleResponse));
    }

    delete(url: string): Observable<Response> {
        return this.http.delete(this.baseUrl + url, {...this.createCustomHeaders(), observe: 'response'}).pipe(map(this.handleResponse));
    }

}
